import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchStore } from "../..";
import useClosable from "../../hooks/useClosable";
import SearchType from "../../interfaces/SearchType";
import { ClosableOrder } from "../../store/ClosableStore";
import SegmentedButtons from "../SegmentedButtons";
import RecentItems from "./RecentItems";
import styles from './SearchPanel.module.css';
import SearchResults from "./SearchResults";

function SearchPanel() {
    const searchStore = useSearchStore();
    const segmentedButtons = useMemo(() => [
        { value: SearchType.Address, label: "Address" },
        { value: SearchType.Deals, label: "Deals" },
        { value: SearchType.Leads, label: "Leads" },
    ], []);
    const [itemCount, setItemCount] = useState(0);

    const close = () => searchStore.setIsOpen(false);
    useClosable(ClosableOrder.High, close);

    const onKeyUp = useCallback((e: KeyboardEvent) => {
        if (e.key === "ArrowDown") {
            searchStore.moveSelectedItemIndexDown(itemCount);
        } else if (e.key === "ArrowUp") {
            searchStore.moveSelectedItemIndexUp(itemCount);
        } else if (e.key === "Enter") {
            searchStore.openSelectedItem();
        }
    }, [itemCount]);

    useEffect(() => {
        window.addEventListener("keyup", onKeyUp);
        return () => window.removeEventListener("keyup", onKeyUp);
    }, [onKeyUp]);

    return (
        <>
            <div
                className={styles.background}
                onClick={close}
            ></div>
            <div className={styles.container}>
                <SegmentedButtons
                    value={searchStore.type}
                    onChange={value => searchStore.setType(value)}
                    options={segmentedButtons}
                />
                {searchStore.query.length < 3
                    ? (
                        <RecentItems setItemCount={setItemCount} />
                    ) : (
                        <SearchResults setItemCount={setItemCount} />
                    )}
            </div>
        </>
    );
}

export default observer(SearchPanel);